
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("gXeK8"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("5Cb5u"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("aJfwH"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("7mM5p"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("abylG"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("z1M41"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("gSKfZ"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("8uOnP"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("7Rj1o"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6YBTn"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("fhsEF"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("2wqk8"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("gXeK8", function(module, exports) {

let $c57d97ba5477cad5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c57d97ba5477cad5$var$load("2YffH"),
    $c57d97ba5477cad5$var$load("8Kivm"),
    $c57d97ba5477cad5$var$load("cf5vC"),
    $c57d97ba5477cad5$var$load("8HLJo"),
    $c57d97ba5477cad5$var$load("3CxIq"),
    $c57d97ba5477cad5$var$load("iQ0Jm"),
    $c57d97ba5477cad5$var$load("coJiW"),
    $c57d97ba5477cad5$var$load("1iq83"),
    $c57d97ba5477cad5$var$load("6xnuw"),
    $c57d97ba5477cad5$var$load("h4Nf7"),
    $c57d97ba5477cad5$var$load("7f9Fz"),
    $c57d97ba5477cad5$var$load("8YSo7"),
    $c57d97ba5477cad5$var$load("fqGSw"),
    $c57d97ba5477cad5$var$load("2Cftu"),
    $c57d97ba5477cad5$var$load("4i0CB"),
    $c57d97ba5477cad5$var$load("g9CVe"),
    $c57d97ba5477cad5$var$load("49GA1"),
    $c57d97ba5477cad5$var$load("32K9i"),
    $c57d97ba5477cad5$var$load("aeEUI"),
    $c57d97ba5477cad5$var$load("iXzmH"),
    $c57d97ba5477cad5$var$load("65c4i"),
    $c57d97ba5477cad5$var$load("6wr18"),
    $c57d97ba5477cad5$var$load("kjZZD"),
    $c57d97ba5477cad5$var$load("3TTZL"),
    $c57d97ba5477cad5$var$load("37ldp"),
    $c57d97ba5477cad5$var$load("jkPqm"),
    $c57d97ba5477cad5$var$load("awqCy"),
    $c57d97ba5477cad5$var$load("kHOMt"),
    $c57d97ba5477cad5$var$load("hhss7"),
    $c57d97ba5477cad5$var$load("ePdWC"),
    $c57d97ba5477cad5$var$load("lBzRN"),
    $c57d97ba5477cad5$var$load("9wxKg"),
    $c57d97ba5477cad5$var$load("Wowvf"),
    $c57d97ba5477cad5$var$load("6O8m6"),
    $c57d97ba5477cad5$var$load("5GxU8"),
    $c57d97ba5477cad5$var$load("7whwt"),
    $c57d97ba5477cad5$var$load("699ae"),
    $c57d97ba5477cad5$var$load("i7QCq"),
    $c57d97ba5477cad5$var$load("let0D"),
    $c57d97ba5477cad5$var$load("87NBA"),
    $c57d97ba5477cad5$var$load("6M36W"),
    $c57d97ba5477cad5$var$load("ffEVr"),
    $c57d97ba5477cad5$var$load("kUbUu"),
    $c57d97ba5477cad5$var$load("9ftJe"),
    $c57d97ba5477cad5$var$load("hUIij"),
    $c57d97ba5477cad5$var$load("6Up0b"),
    $c57d97ba5477cad5$var$load("lnKog"),
    $c57d97ba5477cad5$var$load("7Omhy"),
    $c57d97ba5477cad5$var$load("kC80R"),
    $c57d97ba5477cad5$var$load("7EorR"),
    $c57d97ba5477cad5$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("5Cb5u", function(module, exports) {

let $41691a1ba560a017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41691a1ba560a017$var$load("2YffH"),
    $41691a1ba560a017$var$load("8Kivm"),
    $41691a1ba560a017$var$load("cf5vC"),
    $41691a1ba560a017$var$load("8HLJo"),
    $41691a1ba560a017$var$load("3CxIq"),
    $41691a1ba560a017$var$load("iQ0Jm"),
    $41691a1ba560a017$var$load("coJiW"),
    $41691a1ba560a017$var$load("1iq83"),
    $41691a1ba560a017$var$load("6xnuw"),
    $41691a1ba560a017$var$load("h4Nf7"),
    $41691a1ba560a017$var$load("7f9Fz"),
    $41691a1ba560a017$var$load("8YSo7"),
    $41691a1ba560a017$var$load("fqGSw"),
    $41691a1ba560a017$var$load("2Cftu"),
    $41691a1ba560a017$var$load("4i0CB"),
    $41691a1ba560a017$var$load("g9CVe"),
    $41691a1ba560a017$var$load("49GA1"),
    $41691a1ba560a017$var$load("32K9i"),
    $41691a1ba560a017$var$load("aeEUI"),
    $41691a1ba560a017$var$load("iXzmH"),
    $41691a1ba560a017$var$load("65c4i"),
    $41691a1ba560a017$var$load("6wr18"),
    $41691a1ba560a017$var$load("kjZZD"),
    $41691a1ba560a017$var$load("3TTZL"),
    $41691a1ba560a017$var$load("37ldp"),
    $41691a1ba560a017$var$load("jkPqm"),
    $41691a1ba560a017$var$load("awqCy"),
    $41691a1ba560a017$var$load("kHOMt"),
    $41691a1ba560a017$var$load("hhss7"),
    $41691a1ba560a017$var$load("ePdWC"),
    $41691a1ba560a017$var$load("lBzRN"),
    $41691a1ba560a017$var$load("9wxKg"),
    $41691a1ba560a017$var$load("Wowvf"),
    $41691a1ba560a017$var$load("6O8m6"),
    $41691a1ba560a017$var$load("5GxU8"),
    $41691a1ba560a017$var$load("7whwt"),
    $41691a1ba560a017$var$load("699ae"),
    $41691a1ba560a017$var$load("i7QCq"),
    $41691a1ba560a017$var$load("let0D"),
    $41691a1ba560a017$var$load("87NBA"),
    $41691a1ba560a017$var$load("6M36W"),
    $41691a1ba560a017$var$load("ffEVr"),
    $41691a1ba560a017$var$load("kUbUu"),
    $41691a1ba560a017$var$load("9ftJe"),
    $41691a1ba560a017$var$load("hUIij"),
    $41691a1ba560a017$var$load("6Up0b"),
    $41691a1ba560a017$var$load("lnKog"),
    $41691a1ba560a017$var$load("7Omhy"),
    $41691a1ba560a017$var$load("kC80R"),
    $41691a1ba560a017$var$load("7EorR"),
    $41691a1ba560a017$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("aJfwH", function(module, exports) {

let $7cfa26940d44b273$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7cfa26940d44b273$var$load("2YffH"),
    $7cfa26940d44b273$var$load("8Kivm"),
    $7cfa26940d44b273$var$load("cf5vC"),
    $7cfa26940d44b273$var$load("8HLJo"),
    $7cfa26940d44b273$var$load("3CxIq"),
    $7cfa26940d44b273$var$load("iQ0Jm"),
    $7cfa26940d44b273$var$load("coJiW"),
    $7cfa26940d44b273$var$load("1iq83"),
    $7cfa26940d44b273$var$load("6xnuw"),
    $7cfa26940d44b273$var$load("h4Nf7"),
    $7cfa26940d44b273$var$load("7f9Fz"),
    $7cfa26940d44b273$var$load("8YSo7"),
    $7cfa26940d44b273$var$load("fqGSw"),
    $7cfa26940d44b273$var$load("2Cftu"),
    $7cfa26940d44b273$var$load("4i0CB"),
    $7cfa26940d44b273$var$load("g9CVe"),
    $7cfa26940d44b273$var$load("49GA1"),
    $7cfa26940d44b273$var$load("32K9i"),
    $7cfa26940d44b273$var$load("aeEUI"),
    $7cfa26940d44b273$var$load("iXzmH"),
    $7cfa26940d44b273$var$load("65c4i"),
    $7cfa26940d44b273$var$load("6wr18"),
    $7cfa26940d44b273$var$load("kjZZD"),
    $7cfa26940d44b273$var$load("3TTZL"),
    $7cfa26940d44b273$var$load("37ldp"),
    $7cfa26940d44b273$var$load("jkPqm"),
    $7cfa26940d44b273$var$load("awqCy"),
    $7cfa26940d44b273$var$load("kHOMt"),
    $7cfa26940d44b273$var$load("hhss7"),
    $7cfa26940d44b273$var$load("ePdWC"),
    $7cfa26940d44b273$var$load("lBzRN"),
    $7cfa26940d44b273$var$load("9wxKg"),
    $7cfa26940d44b273$var$load("Wowvf"),
    $7cfa26940d44b273$var$load("6O8m6"),
    $7cfa26940d44b273$var$load("5GxU8"),
    $7cfa26940d44b273$var$load("7whwt"),
    $7cfa26940d44b273$var$load("699ae"),
    $7cfa26940d44b273$var$load("i7QCq"),
    $7cfa26940d44b273$var$load("let0D"),
    $7cfa26940d44b273$var$load("87NBA"),
    $7cfa26940d44b273$var$load("6M36W"),
    $7cfa26940d44b273$var$load("ffEVr"),
    $7cfa26940d44b273$var$load("kUbUu"),
    $7cfa26940d44b273$var$load("9ftJe"),
    $7cfa26940d44b273$var$load("hUIij"),
    $7cfa26940d44b273$var$load("6Up0b"),
    $7cfa26940d44b273$var$load("lnKog"),
    $7cfa26940d44b273$var$load("7Omhy"),
    $7cfa26940d44b273$var$load("kC80R"),
    $7cfa26940d44b273$var$load("7EorR"),
    $7cfa26940d44b273$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("7mM5p", function(module, exports) {

let $55cfe3643d4415ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $55cfe3643d4415ea$var$load("2YffH"),
    $55cfe3643d4415ea$var$load("cf5vC"),
    $55cfe3643d4415ea$var$load("8HLJo"),
    $55cfe3643d4415ea$var$load("3CxIq"),
    $55cfe3643d4415ea$var$load("1iq83"),
    $55cfe3643d4415ea$var$load("6xnuw"),
    $55cfe3643d4415ea$var$load("h4Nf7"),
    $55cfe3643d4415ea$var$load("7f9Fz"),
    $55cfe3643d4415ea$var$load("8YSo7"),
    $55cfe3643d4415ea$var$load("fqGSw"),
    $55cfe3643d4415ea$var$load("g9CVe"),
    $55cfe3643d4415ea$var$load("49GA1"),
    $55cfe3643d4415ea$var$load("32K9i"),
    $55cfe3643d4415ea$var$load("aeEUI"),
    $55cfe3643d4415ea$var$load("iXzmH"),
    $55cfe3643d4415ea$var$load("65c4i"),
    $55cfe3643d4415ea$var$load("6wr18"),
    $55cfe3643d4415ea$var$load("kjZZD"),
    $55cfe3643d4415ea$var$load("3TTZL"),
    $55cfe3643d4415ea$var$load("37ldp"),
    $55cfe3643d4415ea$var$load("jkPqm"),
    $55cfe3643d4415ea$var$load("awqCy"),
    $55cfe3643d4415ea$var$load("kHOMt"),
    $55cfe3643d4415ea$var$load("hhss7"),
    $55cfe3643d4415ea$var$load("ePdWC"),
    $55cfe3643d4415ea$var$load("lBzRN"),
    $55cfe3643d4415ea$var$load("9wxKg"),
    $55cfe3643d4415ea$var$load("Wowvf"),
    $55cfe3643d4415ea$var$load("6O8m6"),
    $55cfe3643d4415ea$var$load("5GxU8"),
    $55cfe3643d4415ea$var$load("7whwt"),
    $55cfe3643d4415ea$var$load("699ae"),
    $55cfe3643d4415ea$var$load("i7QCq"),
    $55cfe3643d4415ea$var$load("let0D"),
    $55cfe3643d4415ea$var$load("87NBA"),
    $55cfe3643d4415ea$var$load("6M36W"),
    $55cfe3643d4415ea$var$load("hUIij"),
    $55cfe3643d4415ea$var$load("ffEVr"),
    $55cfe3643d4415ea$var$load("kUbUu"),
    $55cfe3643d4415ea$var$load("9ftJe"),
    $55cfe3643d4415ea$var$load("7Omhy"),
    $55cfe3643d4415ea$var$load("kC80R"),
    $55cfe3643d4415ea$var$load("7EorR"),
    $55cfe3643d4415ea$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("abylG", function(module, exports) {

let $76a5936ab285bd57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76a5936ab285bd57$var$load("2YffH"),
    $76a5936ab285bd57$var$load("cf5vC"),
    $76a5936ab285bd57$var$load("8HLJo"),
    $76a5936ab285bd57$var$load("3CxIq"),
    $76a5936ab285bd57$var$load("1iq83"),
    $76a5936ab285bd57$var$load("6xnuw"),
    $76a5936ab285bd57$var$load("h4Nf7"),
    $76a5936ab285bd57$var$load("7f9Fz"),
    $76a5936ab285bd57$var$load("8YSo7"),
    $76a5936ab285bd57$var$load("fqGSw"),
    $76a5936ab285bd57$var$load("g9CVe"),
    $76a5936ab285bd57$var$load("49GA1"),
    $76a5936ab285bd57$var$load("32K9i"),
    $76a5936ab285bd57$var$load("aeEUI"),
    $76a5936ab285bd57$var$load("iXzmH"),
    $76a5936ab285bd57$var$load("65c4i"),
    $76a5936ab285bd57$var$load("6wr18"),
    $76a5936ab285bd57$var$load("kjZZD"),
    $76a5936ab285bd57$var$load("3TTZL"),
    $76a5936ab285bd57$var$load("37ldp"),
    $76a5936ab285bd57$var$load("jkPqm"),
    $76a5936ab285bd57$var$load("awqCy"),
    $76a5936ab285bd57$var$load("kHOMt"),
    $76a5936ab285bd57$var$load("hhss7"),
    $76a5936ab285bd57$var$load("ePdWC"),
    $76a5936ab285bd57$var$load("lBzRN"),
    $76a5936ab285bd57$var$load("9wxKg"),
    $76a5936ab285bd57$var$load("Wowvf"),
    $76a5936ab285bd57$var$load("6O8m6"),
    $76a5936ab285bd57$var$load("5GxU8"),
    $76a5936ab285bd57$var$load("7whwt"),
    $76a5936ab285bd57$var$load("699ae"),
    $76a5936ab285bd57$var$load("i7QCq"),
    $76a5936ab285bd57$var$load("let0D"),
    $76a5936ab285bd57$var$load("87NBA"),
    $76a5936ab285bd57$var$load("6M36W"),
    $76a5936ab285bd57$var$load("hUIij"),
    $76a5936ab285bd57$var$load("ffEVr"),
    $76a5936ab285bd57$var$load("kUbUu"),
    $76a5936ab285bd57$var$load("9ftJe"),
    $76a5936ab285bd57$var$load("7Omhy"),
    $76a5936ab285bd57$var$load("kC80R"),
    $76a5936ab285bd57$var$load("7EorR"),
    $76a5936ab285bd57$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("z1M41", function(module, exports) {

let $0694a552bdd15ddc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0694a552bdd15ddc$var$load("2YffH"),
    $0694a552bdd15ddc$var$load("cf5vC"),
    $0694a552bdd15ddc$var$load("8HLJo"),
    $0694a552bdd15ddc$var$load("3CxIq"),
    $0694a552bdd15ddc$var$load("1iq83"),
    $0694a552bdd15ddc$var$load("6xnuw"),
    $0694a552bdd15ddc$var$load("h4Nf7"),
    $0694a552bdd15ddc$var$load("7f9Fz"),
    $0694a552bdd15ddc$var$load("8YSo7"),
    $0694a552bdd15ddc$var$load("fqGSw"),
    $0694a552bdd15ddc$var$load("g9CVe"),
    $0694a552bdd15ddc$var$load("49GA1"),
    $0694a552bdd15ddc$var$load("32K9i"),
    $0694a552bdd15ddc$var$load("aeEUI"),
    $0694a552bdd15ddc$var$load("iXzmH"),
    $0694a552bdd15ddc$var$load("65c4i"),
    $0694a552bdd15ddc$var$load("6wr18"),
    $0694a552bdd15ddc$var$load("kjZZD"),
    $0694a552bdd15ddc$var$load("3TTZL"),
    $0694a552bdd15ddc$var$load("37ldp"),
    $0694a552bdd15ddc$var$load("jkPqm"),
    $0694a552bdd15ddc$var$load("awqCy"),
    $0694a552bdd15ddc$var$load("kHOMt"),
    $0694a552bdd15ddc$var$load("hhss7"),
    $0694a552bdd15ddc$var$load("ePdWC"),
    $0694a552bdd15ddc$var$load("lBzRN"),
    $0694a552bdd15ddc$var$load("9wxKg"),
    $0694a552bdd15ddc$var$load("Wowvf"),
    $0694a552bdd15ddc$var$load("6O8m6"),
    $0694a552bdd15ddc$var$load("5GxU8"),
    $0694a552bdd15ddc$var$load("7whwt"),
    $0694a552bdd15ddc$var$load("699ae"),
    $0694a552bdd15ddc$var$load("i7QCq"),
    $0694a552bdd15ddc$var$load("let0D"),
    $0694a552bdd15ddc$var$load("87NBA"),
    $0694a552bdd15ddc$var$load("6M36W"),
    $0694a552bdd15ddc$var$load("hUIij"),
    $0694a552bdd15ddc$var$load("ffEVr"),
    $0694a552bdd15ddc$var$load("kUbUu"),
    $0694a552bdd15ddc$var$load("9ftJe"),
    $0694a552bdd15ddc$var$load("7Omhy"),
    $0694a552bdd15ddc$var$load("kC80R"),
    $0694a552bdd15ddc$var$load("7EorR"),
    $0694a552bdd15ddc$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("gSKfZ", function(module, exports) {

let $c4a592265bdf058a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4a592265bdf058a$var$load("2YffH"),
    $c4a592265bdf058a$var$load("cf5vC"),
    $c4a592265bdf058a$var$load("8HLJo"),
    $c4a592265bdf058a$var$load("3CxIq"),
    $c4a592265bdf058a$var$load("1iq83"),
    $c4a592265bdf058a$var$load("6xnuw"),
    $c4a592265bdf058a$var$load("h4Nf7"),
    $c4a592265bdf058a$var$load("7f9Fz"),
    $c4a592265bdf058a$var$load("8YSo7"),
    $c4a592265bdf058a$var$load("fqGSw"),
    $c4a592265bdf058a$var$load("g9CVe"),
    $c4a592265bdf058a$var$load("49GA1"),
    $c4a592265bdf058a$var$load("32K9i"),
    $c4a592265bdf058a$var$load("aeEUI"),
    $c4a592265bdf058a$var$load("iXzmH"),
    $c4a592265bdf058a$var$load("65c4i"),
    $c4a592265bdf058a$var$load("6wr18"),
    $c4a592265bdf058a$var$load("kjZZD"),
    $c4a592265bdf058a$var$load("3TTZL"),
    $c4a592265bdf058a$var$load("37ldp"),
    $c4a592265bdf058a$var$load("jkPqm"),
    $c4a592265bdf058a$var$load("awqCy"),
    $c4a592265bdf058a$var$load("kHOMt"),
    $c4a592265bdf058a$var$load("hhss7"),
    $c4a592265bdf058a$var$load("ePdWC"),
    $c4a592265bdf058a$var$load("lBzRN"),
    $c4a592265bdf058a$var$load("9wxKg"),
    $c4a592265bdf058a$var$load("Wowvf"),
    $c4a592265bdf058a$var$load("6O8m6"),
    $c4a592265bdf058a$var$load("5GxU8"),
    $c4a592265bdf058a$var$load("7whwt"),
    $c4a592265bdf058a$var$load("699ae"),
    $c4a592265bdf058a$var$load("i7QCq"),
    $c4a592265bdf058a$var$load("let0D"),
    $c4a592265bdf058a$var$load("87NBA"),
    $c4a592265bdf058a$var$load("6M36W"),
    $c4a592265bdf058a$var$load("ffEVr"),
    $c4a592265bdf058a$var$load("kUbUu"),
    $c4a592265bdf058a$var$load("9ftJe"),
    $c4a592265bdf058a$var$load("hUIij"),
    $c4a592265bdf058a$var$load("6Up0b"),
    $c4a592265bdf058a$var$load("lnKog"),
    $c4a592265bdf058a$var$load("7Omhy"),
    $c4a592265bdf058a$var$load("kC80R"),
    $c4a592265bdf058a$var$load("7EorR"),
    $c4a592265bdf058a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("8uOnP", function(module, exports) {

let $62f8352d70c22fa4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $62f8352d70c22fa4$var$load("2YffH"),
    $62f8352d70c22fa4$var$load("cf5vC"),
    $62f8352d70c22fa4$var$load("8HLJo"),
    $62f8352d70c22fa4$var$load("3CxIq"),
    $62f8352d70c22fa4$var$load("coJiW"),
    $62f8352d70c22fa4$var$load("1iq83"),
    $62f8352d70c22fa4$var$load("6xnuw"),
    $62f8352d70c22fa4$var$load("h4Nf7"),
    $62f8352d70c22fa4$var$load("7f9Fz"),
    $62f8352d70c22fa4$var$load("8YSo7"),
    $62f8352d70c22fa4$var$load("fqGSw"),
    $62f8352d70c22fa4$var$load("2Cftu"),
    $62f8352d70c22fa4$var$load("4i0CB"),
    $62f8352d70c22fa4$var$load("g9CVe"),
    $62f8352d70c22fa4$var$load("49GA1"),
    $62f8352d70c22fa4$var$load("32K9i"),
    $62f8352d70c22fa4$var$load("aeEUI"),
    $62f8352d70c22fa4$var$load("iXzmH"),
    $62f8352d70c22fa4$var$load("65c4i"),
    $62f8352d70c22fa4$var$load("6wr18"),
    $62f8352d70c22fa4$var$load("kjZZD"),
    $62f8352d70c22fa4$var$load("3TTZL"),
    $62f8352d70c22fa4$var$load("37ldp"),
    $62f8352d70c22fa4$var$load("jkPqm"),
    $62f8352d70c22fa4$var$load("dTsOE"),
    $62f8352d70c22fa4$var$load("awqCy"),
    $62f8352d70c22fa4$var$load("kHOMt"),
    $62f8352d70c22fa4$var$load("hhss7"),
    $62f8352d70c22fa4$var$load("ePdWC"),
    $62f8352d70c22fa4$var$load("lBzRN"),
    $62f8352d70c22fa4$var$load("9wxKg"),
    $62f8352d70c22fa4$var$load("Wowvf"),
    $62f8352d70c22fa4$var$load("6O8m6"),
    $62f8352d70c22fa4$var$load("5GxU8"),
    $62f8352d70c22fa4$var$load("7whwt"),
    $62f8352d70c22fa4$var$load("699ae"),
    $62f8352d70c22fa4$var$load("i7QCq"),
    $62f8352d70c22fa4$var$load("let0D"),
    $62f8352d70c22fa4$var$load("87NBA"),
    $62f8352d70c22fa4$var$load("6M36W"),
    $62f8352d70c22fa4$var$load("ffEVr"),
    $62f8352d70c22fa4$var$load("kUbUu"),
    $62f8352d70c22fa4$var$load("9ftJe"),
    $62f8352d70c22fa4$var$load("hUIij"),
    $62f8352d70c22fa4$var$load("6Up0b"),
    $62f8352d70c22fa4$var$load("lnKog"),
    $62f8352d70c22fa4$var$load("7Omhy"),
    $62f8352d70c22fa4$var$load("kC80R"),
    $62f8352d70c22fa4$var$load("7EorR"),
    $62f8352d70c22fa4$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("7Rj1o", function(module, exports) {

let $5b8c3ce9e1b52b00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b8c3ce9e1b52b00$var$load("2YffH"),
    $5b8c3ce9e1b52b00$var$load("cf5vC"),
    $5b8c3ce9e1b52b00$var$load("8HLJo"),
    $5b8c3ce9e1b52b00$var$load("3CxIq"),
    $5b8c3ce9e1b52b00$var$load("coJiW"),
    $5b8c3ce9e1b52b00$var$load("1iq83"),
    $5b8c3ce9e1b52b00$var$load("6xnuw"),
    $5b8c3ce9e1b52b00$var$load("h4Nf7"),
    $5b8c3ce9e1b52b00$var$load("7f9Fz"),
    $5b8c3ce9e1b52b00$var$load("8YSo7"),
    $5b8c3ce9e1b52b00$var$load("fqGSw"),
    $5b8c3ce9e1b52b00$var$load("2Cftu"),
    $5b8c3ce9e1b52b00$var$load("4i0CB"),
    $5b8c3ce9e1b52b00$var$load("g9CVe"),
    $5b8c3ce9e1b52b00$var$load("49GA1"),
    $5b8c3ce9e1b52b00$var$load("32K9i"),
    $5b8c3ce9e1b52b00$var$load("aeEUI"),
    $5b8c3ce9e1b52b00$var$load("iXzmH"),
    $5b8c3ce9e1b52b00$var$load("65c4i"),
    $5b8c3ce9e1b52b00$var$load("6wr18"),
    $5b8c3ce9e1b52b00$var$load("kjZZD"),
    $5b8c3ce9e1b52b00$var$load("3TTZL"),
    $5b8c3ce9e1b52b00$var$load("37ldp"),
    $5b8c3ce9e1b52b00$var$load("jkPqm"),
    $5b8c3ce9e1b52b00$var$load("dTsOE"),
    $5b8c3ce9e1b52b00$var$load("awqCy"),
    $5b8c3ce9e1b52b00$var$load("kHOMt"),
    $5b8c3ce9e1b52b00$var$load("hhss7"),
    $5b8c3ce9e1b52b00$var$load("ePdWC"),
    $5b8c3ce9e1b52b00$var$load("lBzRN"),
    $5b8c3ce9e1b52b00$var$load("9wxKg"),
    $5b8c3ce9e1b52b00$var$load("Wowvf"),
    $5b8c3ce9e1b52b00$var$load("6O8m6"),
    $5b8c3ce9e1b52b00$var$load("5GxU8"),
    $5b8c3ce9e1b52b00$var$load("7whwt"),
    $5b8c3ce9e1b52b00$var$load("699ae"),
    $5b8c3ce9e1b52b00$var$load("i7QCq"),
    $5b8c3ce9e1b52b00$var$load("let0D"),
    $5b8c3ce9e1b52b00$var$load("87NBA"),
    $5b8c3ce9e1b52b00$var$load("6M36W"),
    $5b8c3ce9e1b52b00$var$load("ffEVr"),
    $5b8c3ce9e1b52b00$var$load("kUbUu"),
    $5b8c3ce9e1b52b00$var$load("9ftJe"),
    $5b8c3ce9e1b52b00$var$load("hUIij"),
    $5b8c3ce9e1b52b00$var$load("6Up0b"),
    $5b8c3ce9e1b52b00$var$load("lnKog"),
    $5b8c3ce9e1b52b00$var$load("7Omhy"),
    $5b8c3ce9e1b52b00$var$load("kC80R"),
    $5b8c3ce9e1b52b00$var$load("7EorR"),
    $5b8c3ce9e1b52b00$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6YBTn", function(module, exports) {

let $5145bd417652f070$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5145bd417652f070$var$load("2YffH"),
    $5145bd417652f070$var$load("cf5vC"),
    $5145bd417652f070$var$load("8HLJo"),
    $5145bd417652f070$var$load("3CxIq"),
    $5145bd417652f070$var$load("1iq83"),
    $5145bd417652f070$var$load("6xnuw"),
    $5145bd417652f070$var$load("h4Nf7"),
    $5145bd417652f070$var$load("7f9Fz"),
    $5145bd417652f070$var$load("8YSo7"),
    $5145bd417652f070$var$load("fqGSw"),
    $5145bd417652f070$var$load("g9CVe"),
    $5145bd417652f070$var$load("49GA1"),
    $5145bd417652f070$var$load("32K9i"),
    $5145bd417652f070$var$load("aeEUI"),
    $5145bd417652f070$var$load("iXzmH"),
    $5145bd417652f070$var$load("65c4i"),
    $5145bd417652f070$var$load("6wr18"),
    $5145bd417652f070$var$load("kjZZD"),
    $5145bd417652f070$var$load("3TTZL"),
    $5145bd417652f070$var$load("37ldp"),
    $5145bd417652f070$var$load("jkPqm"),
    $5145bd417652f070$var$load("awqCy"),
    $5145bd417652f070$var$load("kHOMt"),
    $5145bd417652f070$var$load("hhss7"),
    $5145bd417652f070$var$load("ePdWC"),
    $5145bd417652f070$var$load("lBzRN"),
    $5145bd417652f070$var$load("9wxKg"),
    $5145bd417652f070$var$load("Wowvf"),
    $5145bd417652f070$var$load("6O8m6"),
    $5145bd417652f070$var$load("5GxU8"),
    $5145bd417652f070$var$load("7whwt"),
    $5145bd417652f070$var$load("699ae"),
    $5145bd417652f070$var$load("i7QCq"),
    $5145bd417652f070$var$load("let0D"),
    $5145bd417652f070$var$load("87NBA"),
    $5145bd417652f070$var$load("6M36W"),
    $5145bd417652f070$var$load("hUIij"),
    $5145bd417652f070$var$load("ffEVr"),
    $5145bd417652f070$var$load("kUbUu"),
    $5145bd417652f070$var$load("9ftJe"),
    $5145bd417652f070$var$load("7Omhy"),
    $5145bd417652f070$var$load("kC80R"),
    $5145bd417652f070$var$load("7EorR"),
    $5145bd417652f070$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("fhsEF", function(module, exports) {

let $b1feabd6c577de9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1feabd6c577de9f$var$load("2YffH"),
    $b1feabd6c577de9f$var$load("cf5vC"),
    $b1feabd6c577de9f$var$load("8HLJo"),
    $b1feabd6c577de9f$var$load("3CxIq"),
    $b1feabd6c577de9f$var$load("1iq83"),
    $b1feabd6c577de9f$var$load("6xnuw"),
    $b1feabd6c577de9f$var$load("h4Nf7"),
    $b1feabd6c577de9f$var$load("7f9Fz"),
    $b1feabd6c577de9f$var$load("8YSo7"),
    $b1feabd6c577de9f$var$load("fqGSw"),
    $b1feabd6c577de9f$var$load("g9CVe"),
    $b1feabd6c577de9f$var$load("49GA1"),
    $b1feabd6c577de9f$var$load("32K9i"),
    $b1feabd6c577de9f$var$load("aeEUI"),
    $b1feabd6c577de9f$var$load("iXzmH"),
    $b1feabd6c577de9f$var$load("65c4i"),
    $b1feabd6c577de9f$var$load("6wr18"),
    $b1feabd6c577de9f$var$load("kjZZD"),
    $b1feabd6c577de9f$var$load("3TTZL"),
    $b1feabd6c577de9f$var$load("37ldp"),
    $b1feabd6c577de9f$var$load("jkPqm"),
    $b1feabd6c577de9f$var$load("awqCy"),
    $b1feabd6c577de9f$var$load("kHOMt"),
    $b1feabd6c577de9f$var$load("hhss7"),
    $b1feabd6c577de9f$var$load("ePdWC"),
    $b1feabd6c577de9f$var$load("lBzRN"),
    $b1feabd6c577de9f$var$load("9wxKg"),
    $b1feabd6c577de9f$var$load("Wowvf"),
    $b1feabd6c577de9f$var$load("6O8m6"),
    $b1feabd6c577de9f$var$load("5GxU8"),
    $b1feabd6c577de9f$var$load("7whwt"),
    $b1feabd6c577de9f$var$load("699ae"),
    $b1feabd6c577de9f$var$load("i7QCq"),
    $b1feabd6c577de9f$var$load("let0D"),
    $b1feabd6c577de9f$var$load("87NBA"),
    $b1feabd6c577de9f$var$load("6M36W"),
    $b1feabd6c577de9f$var$load("ffEVr"),
    $b1feabd6c577de9f$var$load("kUbUu"),
    $b1feabd6c577de9f$var$load("9ftJe"),
    $b1feabd6c577de9f$var$load("hUIij"),
    $b1feabd6c577de9f$var$load("6Up0b"),
    $b1feabd6c577de9f$var$load("lnKog"),
    $b1feabd6c577de9f$var$load("7Omhy"),
    $b1feabd6c577de9f$var$load("kC80R"),
    $b1feabd6c577de9f$var$load("7EorR"),
    $b1feabd6c577de9f$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("2wqk8", function(module, exports) {

let $1d62fd4d9e199d33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d62fd4d9e199d33$var$load("2YffH"),
    $1d62fd4d9e199d33$var$load("cf5vC"),
    $1d62fd4d9e199d33$var$load("8HLJo"),
    $1d62fd4d9e199d33$var$load("3CxIq"),
    $1d62fd4d9e199d33$var$load("1iq83"),
    $1d62fd4d9e199d33$var$load("6xnuw"),
    $1d62fd4d9e199d33$var$load("h4Nf7"),
    $1d62fd4d9e199d33$var$load("7f9Fz"),
    $1d62fd4d9e199d33$var$load("8YSo7"),
    $1d62fd4d9e199d33$var$load("fqGSw"),
    $1d62fd4d9e199d33$var$load("g9CVe"),
    $1d62fd4d9e199d33$var$load("49GA1"),
    $1d62fd4d9e199d33$var$load("32K9i"),
    $1d62fd4d9e199d33$var$load("aeEUI"),
    $1d62fd4d9e199d33$var$load("iXzmH"),
    $1d62fd4d9e199d33$var$load("65c4i"),
    $1d62fd4d9e199d33$var$load("6wr18"),
    $1d62fd4d9e199d33$var$load("kjZZD"),
    $1d62fd4d9e199d33$var$load("3TTZL"),
    $1d62fd4d9e199d33$var$load("37ldp"),
    $1d62fd4d9e199d33$var$load("jkPqm"),
    $1d62fd4d9e199d33$var$load("awqCy"),
    $1d62fd4d9e199d33$var$load("kHOMt"),
    $1d62fd4d9e199d33$var$load("hhss7"),
    $1d62fd4d9e199d33$var$load("ePdWC"),
    $1d62fd4d9e199d33$var$load("lBzRN"),
    $1d62fd4d9e199d33$var$load("9wxKg"),
    $1d62fd4d9e199d33$var$load("Wowvf"),
    $1d62fd4d9e199d33$var$load("6O8m6"),
    $1d62fd4d9e199d33$var$load("5GxU8"),
    $1d62fd4d9e199d33$var$load("7whwt"),
    $1d62fd4d9e199d33$var$load("699ae"),
    $1d62fd4d9e199d33$var$load("i7QCq"),
    $1d62fd4d9e199d33$var$load("let0D"),
    $1d62fd4d9e199d33$var$load("87NBA"),
    $1d62fd4d9e199d33$var$load("6M36W"),
    $1d62fd4d9e199d33$var$load("ffEVr"),
    $1d62fd4d9e199d33$var$load("kUbUu"),
    $1d62fd4d9e199d33$var$load("9ftJe"),
    $1d62fd4d9e199d33$var$load("hUIij"),
    $1d62fd4d9e199d33$var$load("6Up0b"),
    $1d62fd4d9e199d33$var$load("lnKog"),
    $1d62fd4d9e199d33$var$load("7Omhy"),
    $1d62fd4d9e199d33$var$load("kC80R"),
    $1d62fd4d9e199d33$var$load("7EorR"),
    $1d62fd4d9e199d33$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.5ff98264.js.map
